import React from "react";
import { Route, Routes } from "react-router-dom";
import IndexEncashmentType from "./settings/encashmentTypes/IndexEncashmentType";
import IndexDeductionType from "./settings/deductionTypes/IndexDeductionType";
import IndexAbsentPolicy from "./absentPolicy/IndexAbsentPolicy";
import IndexMissingPolicy from "./missingPolicy/IndexMissingPolicy";
import IndexLateArrivalPolicy from "./lateArrivalPolicy/IndexLateArrivalPolicy";
import IndexEarlyLeftPolicy from "./earlyLeftPolicy/IndexEarlyLeftPolicy";
import IndexShortDurationPolicy from "./shortDurationPolicy/IndexShortDurationPolicy";
import IndexRelaxationPolicy from "./relaxationPolicy/IndexRelaxationPolicy";
import IndexLeavePolicy from "./leavePolicy/IndexLeavePolicy";
import IndexOvertimePolicy from "./overtimePolicy/IndexOvertimePolicy";
import IndexCplPolicy from "./cplPolicy/IndexCplPolicy";
import IndexTravelPolicy from "./travelPolicy/IndexTravelPolicy";
import IndexRequestPolicyPlanner from "./requestPolicyPlanner/IndexRequestPolicyPlanner";
import IndexAttendancePolicyPlanner from "./attendancePolicyPlanner/IndexAttendancePolicyPlanner";
import { guardElement } from "@comps/components";


const PolicyManagementModules = () => {
  return (
    <Routes>
      <Route path="settings/encashment-types" element={ guardElement(<IndexEncashmentType modkey="encashmentType"/>, "encashmentType") } />
      <Route path="settings/deduction-types" element={ guardElement(<IndexDeductionType modkey="deductionType"/>, "deductionType") } />
      <Route path="policies/absent-policy" element={ guardElement(<IndexAbsentPolicy modkey="absentPolicy"/>, "absentPolicy") } />
      <Route path="policies/missing-policy" element={ guardElement(<IndexMissingPolicy modkey="missingPolicy"/>, "missingPolicy") } />
      <Route path="policies/late-arrival-policy" element={ guardElement(<IndexLateArrivalPolicy modkey="lateArrivalPolicy"/>, "lateArrivalPolicy") } />
      <Route path="policies/early-left-policy" element={ guardElement(<IndexEarlyLeftPolicy modkey="earlyLeftPolicy"/>, "earlyLeftPolicy") } />
      <Route path="policies/short-duration-policy" element={ guardElement(<IndexShortDurationPolicy modkey="shortDurationPolicy"/>, "shortDurationPolicy") } />
      <Route path="policies/relaxation-policy" element={ guardElement(<IndexRelaxationPolicy modkey="relaxationPolicy"/>, "relaxationPolicy") } />
      <Route path="policies/leave-policy" element={ guardElement(<IndexLeavePolicy modkey="leavePolicy"/>, "leavePolicy") } />
      <Route path="policies/overtime-policy" element={ guardElement(<IndexOvertimePolicy modkey="overtimePolicy"/>, "overtimePolicy") } />
      <Route path="policies/cpl-policy" element={ guardElement(<IndexCplPolicy modkey="cplPolicy"/>, "cplPolicy") } />
      <Route path="request-policies/travel-policy" element={ guardElement(<IndexTravelPolicy modkey="travelPolicy"/>, "travelPolicy") } />
      <Route path="request-policy-planner" element={ guardElement(<IndexRequestPolicyPlanner modkey="requestPolicyPlanners"/>, "requestPolicyPlanners") } />
      <Route path="policy-planer" element={ guardElement(<IndexAttendancePolicyPlanner modkey="requestPolicies"/>, "requestPolicies") } />
     
    </Routes>
  );
}

export default PolicyManagementModules;
